var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth, persistent: "" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "resizable-card", class: { "no-select": _vm.resizing } },
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                { staticClass: "no-gutters" },
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v("Preview " + _vm._s(_vm.rules.name)),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-1",
                      attrs: { color: "green" },
                      on: { click: _vm.exportToJSON },
                    },
                    [_vm._v("Export")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-1",
                      attrs: { color: "blue" },
                      on: { click: _vm.onPressImportJson },
                    },
                    [_vm._v("Import")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("codemirror", {
                staticClass: "cm-editor",
                attrs: { options: _vm.cmOpt },
                model: {
                  value: _vm.model,
                  callback: function ($$v) {
                    _vm.model = $$v
                  },
                  expression: "model",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled:
                      _vm.rules.create === false && _vm.rules.update === false,
                    color: "blue darken-1",
                    text: "",
                  },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("input", {
            ref: "uploaderJson",
            staticClass: "d-none",
            attrs: { type: "file", accept: "application/json" },
            on: { change: _vm.onFileChangedJson },
          }),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }